<template>
  <div class="animated fadeIn">

      <b-col lg="12">
        <c-table :table-data="items" :fields="fields" caption="Data"></c-table>
      </b-col>
  </div>

</template>
<script>
import { shuffleArray } from '@/shared/utils'
import cTable from './Table.vue'
import { async } from 'q'
import { setTimeout } from 'timers'
import numeral from 'numeral'
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import DateFormatter from '../../plugins/dateFormatter'

export default {
  name: 'TrafficDataTable',
  props: ['renderData','selectedSites', 'selectedOverview','selectedPlatform','selectedSource','selectedCategory','selectedOption'],
  components: {cTable},
  data: () => {
    return {
      chartData: [],
      tableData: [],
      items: [],
      fields: [
        {key: 'date', label: 'Date', sortable: true},
        {key: 'site', label: 'Site',sortable: true},
        {key: 'overview'},
        {key: 'value', sortable: true},
        {key: 'platform', sortable: true},
        {key: 'source', sortable: true},
        {key: 'category', sortable: true},
      ],
      backgroundColor: '#16a085',
      
    }
  },
  watch: {
    renderData(newData, oldData){
      this.changeTableData();
    },
    selectedSites(newData,oldData){
      this.changeTableData()
    },
    selectedOverview(newData,oldData){
      this.changeTableData()
    },
    selectedCategory(newData,oldData){
      this.changeTableData()
    },
    selectedSource(newData,oldData){
      this.changeTableData()
    },
    selectedPlatform(newData,oldData){
      this.changeTableData()
    },
    selectedOption(newData,oldData){
      this.changeTableData()
    }
  },
  methods: {
    async setItem(data,site){
      let impressions, ad_requests
      if(data){
        for(let i = 0; i < data.length; i++){
          if(this.selectedOverview===data[i].metric){
            if(this.selectedOption==='Platform'){
              if(this.selectedPlatform.includes(data[i].platform) || (this.selectedPlatform.includes('No Platform') && data[i].platform==='-')){
                await  this.tableData.push(
              {date: DateFormatter(data[i].trafic_date),
              site:site,
              overview:data[i].metric,
              value:data[i]._value,
              platform:data[i].platform,
              source:data[i].source,
              category:data[i].category
              }
              )
              }
            }
            else if(this.selectedOption==='Category'){
              if(this.selectedCategory.includes(data[i].category) || (this.selectedCategory.includes('No Category') && data[i].category==='-')){
                await  this.tableData.push(
              {date: DateFormatter(data[i].trafic_date),
              site:site,
              overview:data[i].metric,
              value:data[i]._value,
              platform:data[i].platform,
              source:data[i].source,
              category:data[i].category
              }
              )
              }
            }
            else if(this.selectedOption==='Source'){
              if( this.selectedSource.includes(data[i].source) || (this.selectedSource.includes('No Source') && data[i].source==='-')){
                await  this.tableData.push(
              {date: DateFormatter(data[i].trafic_date),
              site:site,
              overview:data[i].metric,
              value:data[i]._value,
              platform:data[i].platform,
              source:data[i].source,
              category:data[i].category
              }
              )
              }
            }
          }
        
        }
      }
    },
    async changeTableData(){
      this.tableData= []
      if(this.$store.state.request){
        if(this.$store.state.trafficData.datas){
          if(this.$store.state.trafficData.datas[0]){
            this.chartData = await this.$store.state.trafficData.datas[0];
            numeral.defaultFormat('0,0');
            this.selectedSites.forEach( async element => {
              if(element==="onedioru"){
                await this.setItem(this.chartData.onedioruDatas,"onedio.ru")
              }
              else if(element==="onedioco"){
                await this.setItem(this.chartData.onediocoDatas,"onedio.co")
              }
              else if(element==="onediocom"){
                await this.setItem(this.chartData.onediocomDatas,"onedio.com")
              }
            });      
          }
        }
      if(this.tableData){
        await this.tableData.sort(this.date_sort).reverse()
      }
      this.items = this.tableData;
      }
    },
     date_sort(a, b) {
    return new Date(a.date).getTime() - new Date(b.date).getTime();
}
  },
}
</script>
<style <style lang="scss" scoped>
#table {
	margin: 0 auto;
	width: 500px;
	.input-group-text {
		padding: 0 .5em 0 .5em;
		
		.fa {
			font-size: 12px;
		}
	};
  background-color: aqua
  
}
</style>
